import styled from 'styled-components';

export const DisplayAndPositionStyled = styled.div`
  display: flex;
  flex-direction: column;

  @keyframes blinkBorder {
    0% {
      outline-color: #fcfcfc;
    }
    25% {
      outline-color: #ffb800;
    }
    50% {
      outline-color: #fcfcfc;
    }
    75% {
      outline-color: #ffb800;
    }
    100% {
      outline-color: #fcfcfc;
    }
  }

  .is-blink-border .Polaris-ShadowBevel {
    animation: blinkBorder 2.5s linear infinite;
    outline-width: 2px;
    outline-style: solid;
  }
`;
